import { render, staticRenderFns } from "./ChangePasswordWidget.vue?vue&type=template&id=628dd516&"
import script from "./ChangePasswordWidget.vue?vue&type=script&lang=js&"
export * from "./ChangePasswordWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports